module.exports = "http://cdn.realive.com.ua/src/views/player/documets/lspdbadge/images/ava.png";